import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getABSDetails } from '../../API/API'

function* getABSDetailsSaga(params) {
    try {
        const response = yield call(() => getABSDetails(params.payload)); 
        yield put({type: types.ABS_DETAILS_SUCCESS, payload: response.data});
      }
      catch (error) {
        yield put({type: types.ABS_DETAILS_FAILURE, error});
    }
}

export function* watchABSDetailsSaga() {
    yield takeEvery(types.ABS_DETAILS_INIT, getABSDetailsSaga);
}